
import { toString, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { DocumentDetail_$reflection, DocumentId__get_unwrap, FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, FormState_$reflection, SetId__get_unwrap, ClientApiResponse$1_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection, SetId_$reflection, ConsumableId_$reflection, ToolId_$reflection } from "../../Shared/Shared.js";
import { bool_type, lambda_type, unit_type, int32_type, list_type, record_type, class_type, union_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ensureRequestBodySize } from "../../ErrorHandling.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1, length, append, truncate, partition, map, indexed, choose, head as head_1, tail as tail_1, empty, isEmpty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_errorToast, Cmd_successToast } from "../../Components/Toast.js";
import { toFloat64 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/BigInt.js";
import { maxRequestBodySizeInBytes } from "../../Shared/File.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_1, singleton, empty as empty_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InformationAlert, ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { Input } from "../../Components/Input.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ConfirmationDialog, Dialog } from "../../Components/Dialog.js";
import { Auto_generateBoxedEncoder_437914C6, toString as toString_1 } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { UpdateDocumentDto, UpdateDocumentDto_$reflection } from "../../Shared/Tool.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { DocumentId__get_unwrap as DocumentId__get_unwrap_1 } from "../../Shared/Shared.js";
import { unwrapConsumableId, unwrapDocumentId, unwrapToolId } from "../../Shared/Helper.js";
import { unwrapDocumentId as unwrapDocumentId_1 } from "../../Shared/Helper.js";

export class UploadType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Consumable", "ToolWithQuantity", "Set", "Receiver"];
    }
}

export function UploadType_$reflection() {
    return union_type("Widgets.Dialogs.FileDialog.UploadType", [], UploadType, () => [[["Item", ToolId_$reflection()]], [["Item", ConsumableId_$reflection()]], [["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]], [["Item", string_type]]]);
}

class Upload_FileEntry extends Record {
    constructor(File, Name, Description) {
        super();
        this.File = File;
        this.Name = Name;
        this.Description = Description;
    }
}

function Upload_FileEntry_$reflection() {
    return record_type("Widgets.Dialogs.FileDialog.Upload.FileEntry", [], Upload_FileEntry, () => [["File", class_type("Browser.Types.File", undefined)], ["Name", string_type], ["Description", string_type]]);
}

class Upload_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddFiles", "RemoveFile", "SetFileName", "SetFileDescription", "SetIsVisibleForUserRole", "Upload", "InventoryFileUploaded", "FileUploadedV2", "FetchError"];
    }
}

function Upload_Msg_$reflection() {
    return union_type("Widgets.Dialogs.FileDialog.Upload.Msg", [], Upload_Msg, () => [[["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item1", int32_type], ["Item2", string_type]], [], [], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function Upload_saveToolDocumentCmd(toolId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/tools/", toolId.fields[0], ..."/files"), formData], (Item) => (new Upload_Msg(6, [Item])), (Item_1) => (new Upload_Msg(8, [Item_1])));
}

function Upload_saveConsumableDocumentCmd(consumableId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/consumables/", consumableId.fields[0], ..."/files"), formData], (Item) => (new Upload_Msg(6, [Item])), (Item_1) => (new Upload_Msg(8, [Item_1])));
}

function Upload_saveSetDocumentCmd(setId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/sets/", SetId__get_unwrap(setId), ..."/files"), formData], (Item) => (new Upload_Msg(6, [Item])), (Item_1) => (new Upload_Msg(8, [Item_1])));
}

function Upload_saveReceiverDocumentCmd(receiverId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/receivers/", receiverId, ..."/files"), formData], (Item) => (new Upload_Msg(7, [Item])), (Item_1) => (new Upload_Msg(8, [Item_1])));
}

class Upload_State extends Record {
    constructor(FileEntries, PendingUploads, UploadType, SuccessCallback, OnClose, IsVisibleForUserRole, FormState) {
        super();
        this.FileEntries = FileEntries;
        this.PendingUploads = PendingUploads;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
        this.FormState = FormState;
    }
}

function Upload_State_$reflection() {
    return record_type("Widgets.Dialogs.FileDialog.Upload.State", [], Upload_State, () => [["FileEntries", list_type(Upload_FileEntry_$reflection())], ["PendingUploads", list_type(Upload_FileEntry_$reflection())], ["UploadType", UploadType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["IsVisibleForUserRole", bool_type], ["FormState", FormState_$reflection()]]);
}

function Upload_createUploadCmd(uploadType, entry, isVisibleForUserRole) {
    const formData = new FormData();
    formData.append(entry.File.name, entry.File);
    formData.append("Name", entry.Name);
    formData.append("Description", entry.Description);
    formData.append("IsVisibleForUserRole", toString(isVisibleForUserRole));
    switch (uploadType.tag) {
        case 1:
            return Upload_saveConsumableDocumentCmd(uploadType.fields[0], formData);
        case 2:
            return Upload_saveToolDocumentCmd(uploadType.fields[0], formData);
        case 3:
            return Upload_saveSetDocumentCmd(uploadType.fields[0], formData);
        case 4:
            return Upload_saveReceiverDocumentCmd(uploadType.fields[0], formData);
        default:
            return Upload_saveToolDocumentCmd(uploadType.fields[0], formData);
    }
}

function Upload_uploadNextOrFinish(state) {
    const matchValue = state.PendingUploads;
    if (isEmpty(matchValue)) {
        return [new Upload_State(state.FileEntries, empty(), state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, FormState_get_empty()), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
            state.SuccessCallback();
        }), Cmd_ofEffect((_arg_1) => {
            state.OnClose();
        }), Cmd_successToast("tool.dialog_upload_succes")]))];
    }
    else {
        return [new Upload_State(state.FileEntries, tail_1(matchValue), state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, state.FormState), Upload_createUploadCmd(state.UploadType, head_1(matchValue), state.IsVisibleForUserRole)];
    }
}

function Upload_init(uploadType, successCallback, onClose) {
    return [new Upload_State(empty(), empty(), uploadType, successCallback, onClose, false, FormState_get_empty()), Cmd_none()];
}

function Upload_update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new Upload_State(choose((tupledArg) => {
                if (tupledArg[0] !== msg.fields[0]) {
                    return tupledArg[1];
                }
                else {
                    return undefined;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        case 2:
            return [new Upload_State(map((tupledArg_1) => {
                const e_1 = tupledArg_1[1];
                if (tupledArg_1[0] === msg.fields[0]) {
                    return new Upload_FileEntry(e_1.File, msg.fields[1], e_1.Description);
                }
                else {
                    return e_1;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        case 3:
            return [new Upload_State(map((tupledArg_2) => {
                const e_2 = tupledArg_2[1];
                if (tupledArg_2[0] === msg.fields[0]) {
                    return new Upload_FileEntry(e_2.File, e_2.Name, msg.fields[1]);
                }
                else {
                    return e_2;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        case 4:
            return [new Upload_State(state.FileEntries, state.PendingUploads, state.UploadType, state.SuccessCallback, state.OnClose, !state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        case 5:
            if (isEmpty(state.FileEntries)) {
                return [state, Cmd_none()];
            }
            else {
                return Upload_uploadNextOrFinish(new Upload_State(state.FileEntries, state.FileEntries, state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, FormState__startLoading(state.FormState)));
            }
        case 6:
            if (msg.fields[0].tag === 1) {
                return [new Upload_State(state.FileEntries, empty(), state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0])), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return Upload_uploadNextOrFinish(state);
            }
        case 7:
            if (msg.fields[0].tag === 1) {
                return [new Upload_State(state.FileEntries, empty(), state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0])), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return Upload_uploadNextOrFinish(state);
            }
        case 8:
            return [new Upload_State(state.FileEntries, empty(), state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, FormState_get_empty()), Cmd_none()];
        default: {
            const patternInput = partition((file) => (file.size <= toFloat64(maxRequestBodySizeInBytes)), msg.fields[0]);
            return [new Upload_State(truncate(5, append(state.FileEntries, map((f) => (new Upload_FileEntry(f, "", "")), patternInput[0]))), state.PendingUploads, state.UploadType, state.SuccessCallback, state.OnClose, state.IsVisibleForUserRole, state.FormState), isEmpty(patternInput[1]) ? Cmd_none() : Cmd_errorToast("general.file_too_large_limit")];
        }
    }
}

function Upload_DialogBody(props) {
    let elems_9;
    const t = useTranslation()[0];
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let files;
            const matchValue = draggedFile.files;
            let matchResult, files_1;
            if (matchValue != null) {
                if ((files = matchValue, (files.length > 0) && !props.FormState.IsLoading)) {
                    matchResult = 0;
                    files_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    props.Dispatch(new Upload_Msg(0, [ofArray(files_1)]));
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_9 = toList(delay(() => {
        let matchValue_1;
        return append_1((matchValue_1 = FormState__getValidation(props.FormState, t, "global"), (matchValue_1 == null) ? (empty_1()) : singleton(createElement(ErrorAlert, {
            Label: matchValue_1,
        }))), delay(() => {
            let elems_1, elems, Label, Icon;
            return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append_1(singleton("flex"), delay(() => append_1(singleton("flex-col"), delay(() => append_1(singleton("justify-center"), delay(() => append_1(singleton("items-center"), delay(() => append_1(singleton("mt-4"), delay(() => append_1(singleton("mb-4"), delay(() => append_1(singleton("rounded-lg"), delay(() => append_1(singleton("border"), delay(() => append_1(singleton("border-dashed"), delay(() => append_1(singleton("border-primary"), delay(() => append_1(singleton("p-4"), delay(() => ((dropData.canDrop && dropData.isOver) ? singleton("bg-background") : empty_1()))))))))))))))))))))))))))], ["ref", patternInput_1[1]], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems = [createElement(TextButton, (Label = t("file_upload.select_files_max_5"), (Icon = Upload_File(), {
                ComponentState: (length(props.FileEntries) >= 5) ? "disabled" : formState,
                Icon: unwrap(Icon),
                Label: Label,
                OnClick: () => {
                    const element = document.getElementById("file-upload");
                    element.click();
                },
                TestId: "open-file-explorer-test-id",
                Variant: "blueButton",
            })))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_2 = [reactElement("input", {
                    id: "file-upload",
                    className: join(" ", ["hidden"]),
                    type: "file",
                    multiple: true,
                    disabled: props.FormState.IsLoading,
                    onChange: (ev) => {
                        const fileList = ev.target.files;
                        if (!(fileList == null)) {
                            props.Dispatch(new Upload_Msg(0, [toList(delay(() => map_1((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))))]));
                        }
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_8;
                    return append_1(!isEmpty(props.FileEntries) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_8 = toList(delay(() => map((tupledArg) => {
                        let elems_7, elems_5, elems_3, elems_4, elems_6;
                        const index = tupledArg[0] | 0;
                        const entry = tupledArg[1];
                        return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "min-w-0"])], (elems_3 = [reactElement("span", {
                            className: join(" ", ["text-sm", "truncate", "font-medium"]),
                            children: entry.File.name,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["text-gray-400", "hover:text-red-500", "flex-shrink-0", "ml-2", "cursor-pointer", "disabled:opacity-50", "disabled:cursor-not-allowed"])], ["type", "button"], ["disabled", props.FormState.IsLoading], ["onClick", (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            props.Dispatch(new Upload_Msg(1, [index]));
                        }], (elems_4 = [reactElement("span", {
                            children: "✕",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_6 = [createElement(Input, {
                            ComponentState: formState,
                            Label: t("general.name"),
                            OnChange: (v) => {
                                props.Dispatch(new Upload_Msg(2, [index, v]));
                            },
                            TestId: `file-upload-name-${index}`,
                            Value: entry.Name,
                        }), createElement(Input, {
                            ComponentState: formState,
                            Label: t("general.description"),
                            OnChange: (v_1) => {
                                props.Dispatch(new Upload_Msg(3, [index, v_1]));
                            },
                            TestId: `file-upload-description-${index}`,
                            Value: entry.Description,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
                    }, indexed(props.FileEntries)))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty_1(), delay(() => append_1(singleton(Checkbox({
                        ComponentState: formState,
                        IsChecked: props.IsVisibleForUserRole,
                        Label: t("tool.document_visible_for_user_role"),
                        OnCheck: (_arg_1) => {
                            props.Dispatch(new Upload_Msg(4, []));
                        },
                        TestId: "document-visible-for-user-checkbox",
                    })), delay(() => singleton(createElement(InformationAlert, {
                        Label: t("tool.document_visible_for_user_role_upload_info"),
                    }))))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

export function Upload_FileUploadDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => Upload_init(props.UploadType, props.SuccessCallback, props.OnClose), Upload_update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("general.upload_files"), {
        Body: singleton_1(createElement(Upload_DialogBody, {
            Dispatch: dispatch,
            FileEntries: state_1.FileEntries,
            FormState: state_1.FormState,
            IsVisibleForUserRole: state_1.IsVisibleForUserRole,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-document-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: (state_1.FormState.IsLoading ? true : isEmpty(state_1.FileEntries)) ? "disabled" : "enabled",
            Label: t("general.upload"),
            OnClick: () => {
                dispatch(new Upload_Msg(5, []));
            },
            TestId: "save-document-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

class Edit_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetIsVisibleForUserRole", "SetName", "SetDescription", "UpdateDocument", "DocumentUpdated", "FetchError"];
    }
}

function Edit_Msg_$reflection() {
    return union_type("Widgets.Dialogs.FileDialog.Edit.Msg", [], Edit_Msg, () => [[], [["Item", string_type]], [["Item", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function Edit_updateToolDocumentCmd(toolId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/tools/", toolId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Edit_Msg(4, [Item])), (Item_1) => (new Edit_Msg(5, [Item_1])));
}

function Edit_updateToolWithQuantityDocumentCmd(toolId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/tools-with-quantity/", toolId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Edit_Msg(4, [Item])), (Item_1) => (new Edit_Msg(5, [Item_1])));
}

function Edit_updateConsumableDocumentCmd(consumableId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/consumables/", consumableId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Edit_Msg(4, [Item])), (Item_1) => (new Edit_Msg(5, [Item_1])));
}

function Edit_updateSetDocumentCmd(setId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/sets/", SetId__get_unwrap(setId), "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Edit_Msg(4, [Item])), (Item_1) => (new Edit_Msg(5, [Item_1])));
}

class Edit_State extends Record {
    constructor(FormState, Document$, UploadType, SuccessCallback, OnClose, Dto) {
        super();
        this.FormState = FormState;
        this.Document = Document$;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Dto = Dto;
    }
}

function Edit_State_$reflection() {
    return record_type("Widgets.Dialogs.FileDialog.Edit.State", [], Edit_State, () => [["FormState", FormState_$reflection()], ["Document", DocumentDetail_$reflection()], ["UploadType", UploadType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Dto", UpdateDocumentDto_$reflection()]]);
}

function Edit_init(uploadType, document$, successCallback, onClose) {
    return [new Edit_State(FormState_get_empty(), document$, uploadType, successCallback, onClose, new UpdateDocumentDto(document$.Name, document$.Description, document$.IsVisibleForUserRole)), Cmd_none()];
}

function Edit_update(msg, state) {
    let bind$0040, bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 1:
            return [new Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040 = state.Dto, new UpdateDocumentDto(msg.fields[0], bind$0040.Description, bind$0040.IsVisibleForUserRole))), Cmd_none()];
        case 2:
            return [new Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040_1 = state.Dto, new UpdateDocumentDto(bind$0040_1.Name, msg.fields[0], bind$0040_1.IsVisibleForUserRole))), Cmd_none()];
        case 0:
            return [new Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040_2 = state.Dto, new UpdateDocumentDto(bind$0040_2.Name, bind$0040_2.Description, !state.Dto.IsVisibleForUserRole))), Cmd_none()];
        case 4:
            return [new Edit_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                state.SuccessCallback();
            }), Cmd_ofEffect((_arg_1) => {
                state.OnClose();
            }), Cmd_successToast("tool.dialog_document_edit_success")]))];
        case 5:
            return [new Edit_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
        default: {
            let cmd;
            const matchValue = state.UploadType;
            cmd = ((matchValue.tag === 2) ? Edit_updateToolWithQuantityDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : ((matchValue.tag === 1) ? Edit_updateConsumableDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : ((matchValue.tag === 3) ? Edit_updateSetDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : ((matchValue.tag === 4) ? Cmd_OfPromise_either_1((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_3;
                return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/receivers/", matchValue.fields[0], "/files/", ...DocumentId__get_unwrap_1(state.Document.Id)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(state.Dto))], (Item) => (new Edit_Msg(4, [Item])), (Item_1) => (new Edit_Msg(5, [Item_1]))) : Edit_updateToolDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto)))));
            return [new Edit_State(FormState__startLoading(state.FormState), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), cmd];
        }
    }
}

function Edit_DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    const formState = props.FormState.IsLoading ? "disabled" : (props.IsUserAuthorized ? "enabled" : "disabled");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [createElement(Input, {
        ComponentState: formState,
        Label: t("general.name"),
        OnChange: (arg) => {
            props.Dispatch(new Edit_Msg(1, [arg]));
        },
        TestId: "document-name-input",
        Value: props.Name,
    }), createElement(Input, {
        ComponentState: formState,
        Label: t("general.description"),
        OnChange: (arg_1) => {
            props.Dispatch(new Edit_Msg(2, [arg_1]));
        },
        TestId: "document-description-input",
        Value: props.Description,
    }), Checkbox({
        ComponentState: formState,
        IsChecked: props.VisibleForUserRole,
        Label: t("tool.document_visible_for_user_role"),
        OnCheck: (_arg) => {
            props.Dispatch(new Edit_Msg(0, []));
        },
        TestId: "document-visible-for-user-checkbox",
    }), createElement(InformationAlert, {
        Label: t("tool.document_visible_for_user_role_upload_info"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Edit_FileEditDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => Edit_init(props.UploadType, props.Document, props.SuccessCallback, props.OnClose), Edit_update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("tool.dialog_document_edit_button"), {
        Body: singleton_1(createElement(Edit_DialogBody, {
            Description: state_1.Dto.Description,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            IsUserAuthorized: props.IsUserAuthorized,
            Name: state_1.Dto.Name,
            VisibleForUserRole: state_1.Dto.IsVisibleForUserRole,
        })),
        Controls: toList(delay(() => append_1(singleton(createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-document-dialog-test-id",
            Variant: "blueButton",
        })), delay(() => (props.IsUserAuthorized ? singleton(createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Edit_Msg(3, []));
            },
            TestId: "save-document-dialog-test-id",
            Variant: "blueButton",
        })) : empty_1()))))),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

class Delete_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteDocument", "DocumentDeleted", "FetchError"];
    }
}

function Delete_Msg_$reflection() {
    return union_type("Widgets.Dialogs.FileDialog.Delete.Msg", [], Delete_Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function Delete_deleteToolDocumentCmd(toolId, documentId) {
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/tools/", unwrapToolId(toolId), "/files/", ...unwrapDocumentId(documentId)), (Item) => (new Delete_Msg(1, [Item])), (Item_1) => (new Delete_Msg(2, [Item_1])));
}

function Delete_deleteConsumableDocumentCmd(consumableId, documentId) {
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/consumables/", unwrapConsumableId(consumableId), "/files/", ...unwrapDocumentId(documentId)), (Item) => (new Delete_Msg(1, [Item])), (Item_1) => (new Delete_Msg(2, [Item_1])));
}

function Delete_deleteSetDocumentCmd(setId, documentId) {
    const docId = unwrapDocumentId(documentId);
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/sets/", SetId__get_unwrap(setId), "/files/", ...docId), (Item) => (new Delete_Msg(1, [Item])), (Item_1) => (new Delete_Msg(2, [Item_1])));
}

class Delete_State extends Record {
    constructor(FormState, Document$, UploadType, SuccessCallback, OnClose, Dto) {
        super();
        this.FormState = FormState;
        this.Document = Document$;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Dto = Dto;
    }
}

function Delete_State_$reflection() {
    return record_type("Widgets.Dialogs.FileDialog.Delete.State", [], Delete_State, () => [["FormState", FormState_$reflection()], ["Document", DocumentDetail_$reflection()], ["UploadType", UploadType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Dto", UpdateDocumentDto_$reflection()]]);
}

function Delete_init(uploadType, document$, successCallback, onClose) {
    return [new Delete_State(FormState_get_empty(), document$, uploadType, successCallback, onClose, new UpdateDocumentDto(document$.Name, document$.Description, document$.IsVisibleForUserRole)), Cmd_none()];
}

function Delete_update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new Delete_State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
            }
            else {
                return [new Delete_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_document_delete_success")]))];
            }
        }
        case 2:
            return [new Delete_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
        default: {
            let cmd;
            const matchValue = state.UploadType;
            cmd = ((matchValue.tag === 2) ? Delete_deleteToolDocumentCmd(matchValue.fields[0], state.Document.Id) : ((matchValue.tag === 1) ? Delete_deleteConsumableDocumentCmd(matchValue.fields[0], state.Document.Id) : ((matchValue.tag === 3) ? Delete_deleteSetDocumentCmd(matchValue.fields[0], state.Document.Id) : ((matchValue.tag === 4) ? Cmd_OfPromise_either_1((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_3;
                return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), concat("/api/receivers/", matchValue.fields[0], "/files/", ...unwrapDocumentId_1(state.Document.Id)), (Item) => (new Delete_Msg(1, [Item])), (Item_1) => (new Delete_Msg(2, [Item_1]))) : Delete_deleteToolDocumentCmd(matchValue.fields[0], state.Document.Id)))));
            return [new Delete_State(FormState__startLoading(state.FormState), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), cmd];
        }
    }
}

export function Delete_FileDeleteDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => Delete_init(props.UploadType, props.Document, props.SuccessCallback, props.OnClose), Delete_update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    return createElement(ConfirmationDialog, (Title = t("general.delete"), {
        Description: t("tool.dialog_document_delete_msg"),
        FormState: state_1.FormState,
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: state_1.FormState.IsLoading ? (() => {
        }) : (() => {
            patternInput_1[1](new Delete_Msg(0, []));
        }),
        Title: Title,
    }));
}

